import React from 'react';
import { withStyles } from 'material-ui/styles';
import Server from '../core/components/server.js';
import UIApp from '../core/ui/app.js';
import AppDrawer from './ui/app_drawer.js';

const styles = theme => ({
});

class History extends React.Component {
	constructor(props){
		super(props)
		this.server = new Server();
		this.state = {
			results : null,
		}
		this.fetch = this.fetch.bind(this);
	}

	fetch(){
		const $this = this;
		this.server.get('/google/history', {}, function(data){
			$this.setState({results : data});
		});
	}

	componentDidMount(){
		this.fetch();
	}

  render(){
  	const items = this.state.results;
  	var key = 0;
    return(  
      <UIApp title={'Search History'} server={this.server} drawer={<AppDrawer/>}>
      	{items && items.map(item =>
	    		<div key={key++}>
	    			{item.q}
	    		</div>
	  		)}
      </UIApp>        	
    );
  }
}

export default withStyles(styles)(History);


// WEBPACK FOOTER //
// ./src/search/history.js